import { Map, type MapOptions } from './map';
import { type Ref, onMounted } from 'vue';
import { useRuntimeConfig } from 'nuxt/app';

export type UseMapOptions = MapOptions & {
  onReady?: (map: Map) => void;
};

export function useMap(
  element: Ref<HTMLElement | undefined>,
  options: UseMapOptions = {}
) {
  const { staticUrl } = useRuntimeConfig().public;
  onMounted(() => {
    if (!element.value) return;
    const map = new Map(element.value, { ...options, staticUrl });
    options.onReady?.(map);
  });
}
